module.exports = __webpack_public_path__ + "ab028b1234365deb0a3957e7ce0fba88.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/youth-duo.png
// module id = 480
// module chunks = 0